module.exports = __webpack_public_path__ + "img/dr_14.b0ea1cc7.png";